import { CustomToastrAction } from '@/actions/components/custom-toastr';
import {MyTeamService, SUCCESS_REPONSE_CODE, UNPROCESSABLE_ENTITY_RESPONSE_CODE, 
        handleOtherResponseCode, REDIRECT, toastr} from '@/imports-files/pages/clients/activities/index';


export async function getMyTeam(router, setApiError)
{  
  var body = {step: router.query.step};
  const result = await new MyTeamService().getTeamDetails(body);
  setApiError(result.request);
  if(result.status == undefined || result.status != 200)
  {
    const error = new Error('An error occurred while fetching the data.')
    error.status = result.response.status
    throw error
  }
  else
  {
    let role_ids = result.data.user_roles.map((x) => x.value)
    result.data.client.client_users_attributes = result.data.client.client_users_attributes.filter((x) => {
      if(role_ids.includes(x.role_id))
      return x
    });   
    return result.data 
  }
}

export async function addTeamMembers(params, router, quick_setup)
{  
  const body                =   {client: {id: params.client.id, client_users_attributes: params.client.client_users_attributes}} 
  if(quick_setup) body.quick_setup = quick_setup
  const result              =   await new MyTeamService().addTeamMembers(body);
  const status_code         =   result.status || result.response.status;
  const customToastrAction  =   new CustomToastrAction(); 
  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      customToastrAction.setNormalToastr(result.data.success, 'success');
      // toastr.success(result.data.success)
      if(result.data.next_step)
      {
        let next_step = result.data.next_step
        let url = `${REDIRECT.client.quick_setup}${next_step}`;
        (next_step == 'complete') ? router.push(REDIRECT.client.activities) : router.push(url)
      }
      break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      return result.response.data.error
      break;
    default: 
      handleOtherResponseCode(status_code, args.router);
  }
}
